module.exports = __webpack_public_path__ + "static/Natasha_Leighl_headshot_lores-b545e53f5c652f184bea2075810e799a.png";